import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { Skill } from '@shared';

@Component({
  selector: 'mojo-candidate-resume-skill',
  templateUrl: './candidate-resume-skill.component.html',
  styleUrls: ['./candidate-resume-skill.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CandidateResumeSkillComponent {
  @Input()
  skills: Array<Skill>;

  @Input()
  groupName: string;

  @Input()
  keywords: string[];

  trackElement = (index: number, item: { id }) => item;
}
